<template>
    <div class="coupon">
        <template v-if="!removed">
            <div class="labels" v-if="!id">
                <label class="label-text">{{ t("coupons-incentive_text_label") }}</label>
                <label class="label-probability">{{ t("coupons-probability_label") }}</label>
            </div>

            <div class="coupon-text">
                <input
                    type="text"
                    class="form-control"
                    v-model="textField"
                    :disabled="!canChangeName"
                    :placeholder="t('coupons-incentive_text_label')"
                />
                <span class="tooltip" v-if="!canChangeName">
                    {{ t("coupons-name_locked_tooltip") }}
                </span>
            </div>

            <div class="coupon-probability">
                <input
                    type="number"
                    class="form-control"
                    v-model="probabilityField"
                    :disabled="disabled"
                    pattern="[0-9]*"
                    @focus="$emit('focusProbability')"
                    @blur="$emit('blurProbability')"
                />
                <span class="percent">%</span>
            </div>

            <div class="clear"></div>
            <div class="stats" v-if="id">
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{ width: percentUsed + '%' }"
                    ></div>
                </div>
                <span>
                    {{ generated }}
                    {{
                        generated === 1
                            ? t("coupons-generated_singular")
                            : t("coupons-generated_plural")
                    }}
                    {{ t("coupons-conjunction_and") }}
                    {{ used }}
                    <template v-if="used">({{ percentUsed }}%)</template>
                    {{
                        used === 1
                            ? t("coupons-used_singular")
                            : t("coupons-used_plural")
                    }}
                </span>
            </div>
            <div class="clear"></div>
            <div class="coupon-remove" v-if="canDelete">
                <span @click="remove()">{{ t("coupons-delete_coupon") }}</span>
            </div>
        </template>
        <template v-if="removed">
            <div class="remove-notice">
                {{ t("coupons-remove_notice", { 0: textField }) }}
                <a href="" class="undo" @click.prevent="undoRemove()"
                    ><div class="far fa-undo"></div>
                    {{ t("coupons-undo") }}</a
                >
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        status: String,
        text: String,
        probability: Number,
        used: Number,
        generated: Number,
        disabled: Boolean,
        id: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            textField: this.text,
            probabilityField: this.probability,
            idField: this.id,
            state: this.status,
            removed: false,
        };
    },
    computed: {
        percentUsed: function () {
            if (this.generated > 0) {
                return Math.round((this.used / this.generated) * 1000) / 10;
            }
            return 0;
        },
        canChangeName: function () {
            if (this.generated > 0) {
                return false;
            }
            return true;
        },
        canDelete: function () {
            if (!this.id || parseInt(this.generated) === 0) {
                return true;
            }
            return false;
        },
    },
    mounted: function () {
        this.$emit("change", this);
    },
    methods: {
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        remove: function () {
            this.removed = true;
            this.$emit("change", this);
        },
        undoRemove: function () {
            this.removed = false;
            this.$emit("change", this);
        },
        save: function () {
            if (this.idField) {
                var options = keviApi.getOptions(
                    "coupons/" + this.idField,
                    "POST",
                    this.getData(),
                );
            } else {
                var options = keviApi.getOptions(
                    "coupons",
                    "PUT",
                    this.getData(),
                );
            }
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.idField = response.body.id;
                    this.setState("saved");
                }
            });
        },
        getData: function () {
            return { text: this.textField, probability: this.probabilityField };
        },
    },
    watch: {
        probabilityField: function () {
            this.$emit("change", this);
        },
    },
};
</script>
